import React, { useCallback } from 'react';
import { DialogActions, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import LoadingButton from '~/modules/common/components/LoadingButton';
import { useSnackbar } from '~/modules/common/snackbar';
import { useTaskEstimateRowContext } from '../../TaskEstimateRowContext';
import { useRemoveResourceUserTaskAssignment } from './hooks/useRemoveResourceUserTaskAssignment';

export const useStyles = makeStyles(theme => ({
  actionContainer: {
    margin: theme.spacing(1, 2, 1, 0)
  }
}));

export const RemoveTaskAssignmentConfirmationDialogFooter = ({
  isLoading,
  onClose,
  onRemoveTaskAssignmentSuccess,
  refetchQueries,
  updateCache
}) => {
  const classes = useStyles();
  const { showSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();
  const {
    loading,
    removeResourceUserTaskAssignment
  } = useRemoveResourceUserTaskAssignment({
    refetchQueries,
    updateCache
  });

  const { task, resourceEstimate } = useTaskEstimateRowContext();

  const onRemoveTaskAssignmentSubmit = useCallback(async () => {
    const {
      data: {
        removeResourceUserTaskAssignment: { syncedResourceAllocation }
      }
    } = await removeResourceUserTaskAssignment({
      userId: resourceEstimate.resourceUser.id,
      projectId: task.project.id,
      taskId: task.id
    });

    onRemoveTaskAssignmentSuccess({
      taskId: task.id,
      isResourceAllocationDeleted:
        resourceEstimate?.taskResourceUserAllocation &&
        !syncedResourceAllocation
    });

    showSnackbar &&
      showSnackbar(
        formatMessage({
          id: 'removeTaskEstimateDialog.snackbarSuccessMessage'
        })
      );
  }, [
    task,
    resourceEstimate,
    removeResourceUserTaskAssignment,
    onRemoveTaskAssignmentSuccess,
    showSnackbar,
    formatMessage
  ]);

  return (
    <DialogActions className={classes.actionContainer}>
      <Button onClick={onClose} autoFocus>
        <FormattedMessage id="removeTaskEstimateDialog.cancel" />
      </Button>
      <LoadingButton
        color="secondary"
        onClick={onRemoveTaskAssignmentSubmit}
        disabled={isLoading}
        isLoading={loading}
      >
        <FormattedMessage id="removeTaskEstimateDialog.removeEstimate" />
      </LoadingButton>
    </DialogActions>
  );
};

RemoveTaskAssignmentConfirmationDialogFooter.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
  onRemoveTaskAssignmentSuccess: PropTypes.func.isRequired,
  refetchQueries: PropTypes.array,
  updateCache: PropTypes.func
};
